import RevokeWarningModal from './RevokeWarningModal';

export default RevokeWarningModal;
